class EntryPointsHelperClass {
	private static _instance: EntryPointsHelperClass;

	private initialized = false;
	private _entryPointSelector = '#naas-headless-navigation';
	private _entryPointFallbackSelector = '.xfpage-root';
	private _entryPointAuthoringFallbackSelector = '#root';
	private _entryPoint: HTMLElement | null = null;
	private _portalEntryPointId = 'naas-headless-portal';
	private _portalEntryPoint: HTMLElement | null = null;

	public static get instance(): EntryPointsHelperClass {
		if (!EntryPointsHelperClass._instance) {
			EntryPointsHelperClass._instance = new EntryPointsHelperClass();
		}

		return EntryPointsHelperClass._instance;
	}

	public get entryPointSelector() {
		return this._entryPointSelector;
	}

	public get entryPointFallbackSelector() {
		return this._entryPointFallbackSelector;
	}

	public get entryPointAuthoringFallbackSelector() {
		return this._entryPointAuthoringFallbackSelector;
	}

	public get portalEntryPointId() {
		return this._portalEntryPointId;
	}

	public get entryPoint(): HTMLElement | null {
		return this._entryPoint;
	}

	public get portalEntryPoint(): HTMLElement | null {
		return this._portalEntryPoint;
	}

	private createOrSelectEntryPoints() {
		this._entryPoint = document.querySelector<HTMLElement>(
			this.entryPointSelector,
		);
		if (!this._entryPoint)
			this._entryPoint = document.querySelector<HTMLElement>(
				this.entryPointFallbackSelector,
			);

		if (!this._entryPoint) {
			this._entryPoint = document.querySelector<HTMLElement>(
				this.entryPointAuthoringFallbackSelector,
			);
		}
		this.mountPortalEntryElement();
	}

	private mountPortalEntryElement() {
		this._portalEntryPoint = document.querySelector<HTMLDivElement>(
			`#${this.portalEntryPointId}`,
		);
		if (this.portalEntryPoint) return;

		this._portalEntryPoint = document.createElement('div');
		if (this.portalEntryPoint) {
			this._portalEntryPoint.setAttribute('id', this.portalEntryPointId);
			this.entryPoint?.after(this.portalEntryPoint);
		}
	}

	public init() {
		if (this.initialized) return;
		this.createOrSelectEntryPoints();
		this.initialized = true;
	}
}

const EntryPointsHelper = EntryPointsHelperClass.instance;

export { EntryPointsHelperClass };
export default EntryPointsHelper;
